module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/058-myanmar-2cb63a5a867d76e1ae797ba5801c24bc.svg";